import { CommonModule, registerLocaleData } from '@angular/common';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { LOCALE_ID, NgModule, Optional, inject } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AuthInterceptor } from './auth';
import { DatabaseStartingInterceptor } from './database';
import { createTranslateLoader, LANGUAGE_LOADER_CONFIG_TOKEN } from './lang';

import localeUk from '@angular/common/locales/en-GB';
import localeUkExtra from '@angular/common/locales/extra/en-GB';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  imports: [
    CommonModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, [new Optional(), LANGUAGE_LOADER_CONFIG_TOKEN]],
      },
    }),
  ],
  providers: [
    // Outermost, so that every repeated attempt passes AuthInterceptor again.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DatabaseStartingInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    registerLocaleData(localeUk, 'en-GB', localeUkExtra);
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. You should only import Core modules in the AppModule only.'
      );
    }
  }
}
